import PaymentAndOrderTypesConfig from './PaymentAndOrderTypesConfig.view';

export default PaymentAndOrderTypesConfig;
